import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'; // ✅ Ավելացված է
import { API_BASE } from './apiConfig'; 

const OrderModal = ({ isOpen, onClose, serviceName, servicePrice, wCount, message, userId, extraData }) => {
    const { t } = useTranslation(); // ✅ i18n հուկ
    const [loadingLocation, setLoadingLocation] = useState(false);
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [showErrors, setShowErrors] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    const [formData, setFormData] = useState({ 
        name: '', phone: '', location: '', date: '', time: '', description: ''    
    });

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        
        if (isOpen) {
            const stored = localStorage.getItem('liber_user');
            const userData = stored ? JSON.parse(stored) : null;
            if (userData) {
                setFormData(prev => ({
                    ...prev,
                    name: userData.full_name || '',
                    phone: userData.phone || '',
                    location: userData.address || ''
                }));
            }
        }
        return () => window.removeEventListener('resize', handleResize);
    }, [isOpen]);

    if (!isOpen) return null;

    const getTimeSlots = () => {
        const slots = [];
        for (let i = 9; i <= 21; i++) {
            slots.push(`${i}:00`, `${i}:30`);
        }
        return slots;
    };

    const getLocation = () => {
        if (!navigator.geolocation) return alert(t('gps_not_supported'));
        setLoadingLocation(true);
        navigator.geolocation.getCurrentPosition((pos) => {
            const { latitude, longitude } = pos.coords;
            setFormData(prev => ({ 
                ...prev, 
                location: `https://www.google.com/maps?q=${latitude},${longitude}` 
            }));
            setLoadingLocation(false);
        }, () => {
            alert(t('location_fetch_error'));
            setLoadingLocation(false);
        });
    };

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();
        if (!formData.date || !formData.time || !formData.name || !formData.phone) {
            setShowErrors(true);
            return;
        }

        setLoadingSubmit(true);
        const fullDescription = `${message || ''} | ${t('form_notes')}: ${formData.description}`.trim();

        try {
            const response = await fetch(`${API_BASE}/api/orders`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    user_id: userId || null,
                    service_name: serviceName || t('default_service_name'),
                    category_name: "Բեռնափոխադրումներ", 
                    customer_name: formData.name,
                    customer_phone: formData.phone,
                    order_date: formData.date,
                    order_time: formData.time,
                    location: formData.location || "",
                    total_price: Number(servicePrice) || 0,
                    wCount: wCount || 0,
                    message: fullDescription,
                    status: 'new'
                })
            });

            if (!response.ok) throw new Error("Server error");

            const displayPrice = servicePrice ? Number(servicePrice).toLocaleString() : "0";
            
            // Telegram-ի համար թողնում եմ հայերեն կամ կարող ես սա էլ դարձնել դինամիկ
            const telegramMsg = `<b>🚀 ՆՈՐ ՊԱՏՎԵՐ #LIBER</b>\n\n` +
                `👤 <b>Հաճախորդ:</b> ${formData.name}\n` +
                `📞 <b>Հեռախոս:</b> ${formData.phone}\n` +
                `📅 <b>Ժամանակ:</b> ${formData.date} | ${formData.time}\n` +
                `📍 <b>Հասցե:</b> ${formData.location || "Նշված չէ"}\n\n` +
                `🛠 <b>Ծառայություն:</b> ${serviceName}\n` +
                `👷 <b>Բանվոր:</b> ${wCount || 0} հոգի\n` +
                `💰 <b>ԳԻՆ: ${displayPrice} ֏</b>`;

            await fetch(`https://api.telegram.org/bot8265300580:AAFNtfsxOL0UvadNbvzkbZOyqBM9b3kTSN0/sendMessage`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ chat_id: "766751041", text: telegramMsg, parse_mode: 'HTML' })
            });

            alert(t('order_success_msg'));
            setFormData({ name: '', phone: '', location: '', date: '', time: '', description: '' });
            onClose();

        } catch (err) {
            alert(t('order_failed_msg'));
        } finally {
            setLoadingSubmit(false);
        }
    };

    return (
        <div style={st.overlay} onClick={onClose}>
            <div style={{
                ...st.modal, 
                width: isMobile ? '95%' : '450px',
                maxHeight: isMobile ? '90vh' : 'auto'
            }} onClick={e => e.stopPropagation()}>
                
                <div style={st.header}>
                    <button onClick={onClose} style={st.backBtn}>✕</button>
                    <span style={st.headerTitle}>{t('order_confirmation_title')}</span>
                    <div style={{width: '20px'}}></div>
                </div>

                <div style={{
                    ...st.body, 
                    maxHeight: isMobile ? 'calc(90vh - 150px)' : '60vh',
                    paddingBottom: isMobile ? '100px' : '25px'
                }}>
                    <div style={st.summary}>
                        <h3 style={st.serviceTitle}>{serviceName}</h3>
                        <div style={st.priceBadge}>{Number(servicePrice || 0).toLocaleString()} ֏</div>
                        {message && <p style={st.calcNote}>{message}</p>}
                    </div>

                    <div style={st.form}>
                        {showErrors && <div style={st.error}>{t('fill_required_fields')}</div>}
                        
                        <div style={st.inputGroup}>
                            <label style={st.label}>{t('form_full_name')} *</label>
                            <input style={st.input} value={formData.name} onChange={e => setFormData(p => ({...p, name: e.target.value}))} />
                        </div>

                        <div style={st.inputGroup}>
                            <label style={st.label}>{t('form_phone')} *</label>
                            <input style={st.input} value={formData.phone} onChange={e => setFormData(p => ({...p, phone: e.target.value}))} />
                        </div>
                        
                        <div style={{display:'flex', gap:'10px'}}>
                            <div style={{...st.inputGroup, flex: 1}}>
                                <label style={st.label}>{t('form_date')} *</label>
                                <input type="date" style={st.input} value={formData.date} onChange={e => setFormData(p => ({...p, date: e.target.value}))} />
                            </div>
                            <div style={{...st.inputGroup, flex: 1}}>
                                <label style={st.label}>{t('form_time')} *</label>
                                <select style={st.input} value={formData.time} onChange={e => setFormData(p => ({...p, time: e.target.value}))}>
                                    <option value="">{t('form_time')}</option>
                                    {getTimeSlots().map(t => <option key={t} value={t}>{t}</option>)}
                                </select>
                            </div>
                        </div>

                        <div style={st.inputGroup}>
                            <label style={st.label}>{t('form_address')}</label>
                            <div style={{display:'flex', gap:'8px'}}>
                                <input placeholder={t('placeholder_address')} style={{...st.input, flex: 1}} value={formData.location} onChange={e => setFormData(p => ({...p, location: e.target.value}))} />
                                <button onClick={getLocation} style={st.locBtn}>{loadingLocation ? "..." : "📍"}</button>
                            </div>
                        </div>

                        <div style={st.inputGroup}>
                            <label style={st.label}>{t('form_notes')}</label>
                            <textarea style={st.textarea} value={formData.description} onChange={e => setFormData(p => ({...p, description: e.target.value}))} />
                        </div>
                    </div>
                </div>

                <div style={st.footer}>
                    <button onClick={handleSubmit} disabled={loadingSubmit} style={st.submitBtn}>
                        {loadingSubmit ? t('btn_sending') : t('btn_confirm_order')}
                    </button>
                </div>
            </div>
            
            <style>{`
                input, select, textarea { font-size: 16px !important; }
                @media (max-width: 768px) {
                    .partner-card { width: 100% !important; }
                }
            `}</style>
        </div>
    );
};

const st = {
    overlay: { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(15, 23, 42, 0.8)', backdropFilter: 'blur(8px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: '10px' },
    modal: { background: '#fff', borderRadius: '30px', overflow: 'hidden', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 40px rgba(0,0,0,0.3)', position: 'relative' },
    header: { display: 'flex', justifyContent: 'space-between', padding: '15px 20px', borderBottom: '1px solid #eee', alignItems: 'center' },
    headerTitle: { fontWeight: '800', fontSize: '16px', color: '#0f172a' },
    backBtn: { border: 'none', background: '#f1f5f9', width: '35px', height: '35px', borderRadius: '50%', cursor: 'pointer' },
    body: { padding: '20px', overflowY: 'auto' },
    summary: { textAlign: 'center', marginBottom: '20px', background: '#0f172a', padding: '15px', borderRadius: '20px' },
    serviceTitle: { color: '#fff', margin: '0 0 5px', fontSize: '16px' },
    priceBadge: { background: '#c5a059', color: '#fff', padding: '5px 15px', borderRadius: '10px', fontWeight: '800', fontSize: '18px' },
    calcNote: { fontSize: '12px', color: '#ccc', marginTop: '10px' },
    form: { display: 'flex', flexDirection: 'column', gap: '12px' },
    inputGroup: { display: 'flex', flexDirection: 'column', gap: '5px' },
    label: { fontSize: '12px', fontWeight: '700', color: '#64748b' },
    input: { padding: '12px', borderRadius: '12px', border: '1px solid #ddd', background: '#f8fafc' },
    textarea: { padding: '12px', borderRadius: '12px', border: '1px solid #ddd', height: '60px', background: '#f8fafc' },
    locBtn: { background: '#0f172a', color: '#fff', border: 'none', borderRadius: '12px', width: '45px' },
    footer: { padding: '15px 20px', background: '#fff', borderTop: '1px solid #eee' },
    submitBtn: { width: '100%', padding: '16px', background: '#c5a059', color: '#fff', border: 'none', borderRadius: '15px', fontWeight: '800', cursor: 'pointer' },
    error: { color: '#ef4444', fontSize: '12px', textAlign: 'center', paddingBottom: '10px' }
};

export default OrderModal;